import {
  Form as FormAntd,
  Spin as SpinAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const ItemForm = styled(FormAntd.Item)`
  label {
    font-weight: 400;
    font-size: 14px !important;
    line-height: 22px;
    color: #6a6a6a !important;
  }
`;

export const SpinAllSize = styled(SpinAntd)`
  max-height: 100% !important;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;
export const Title = styled(TypographyAntd.Title)`
  font-size: 18px !important;
  color: #676a6c !important;
  font-weight: 700 !important;
  margin-bottom: 16px !important;
`;
